var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Clock icon"),React.createElement("path",{"d":"M105.5 20.7c-47.8 0-86.9 39.1-86.9 86.9s39.1 86.9 86.9 86.9 86.9-39.1 86.9-86.9-39.1-86.9-86.9-86.9zm0 156.4c-38.2 0-69.5-31.3-69.5-69.5s31.3-69.5 69.5-69.5S175 69.4 175 107.6s-31.2 69.5-69.5 69.5z","key":1}),React.createElement("path",{"d":"M109.9 64.2H96.8v52.1l45.2 27.8 7-11.3-39.1-23.4z","key":2})]);
}

Clock.defaultProps = {"id":"googleplus-svg","viewBox":"0 0 210.9 210.9"};

module.exports = Clock;

Clock.default = Clock;
